<template>
  <b-card header-class="bg-transparent">
    <template v-slot:header>
      <span>Set up your investment categories</span>
    </template>
    <b-row class="mb-3">
      <b-col>
        <p class="text-secondary">
          These categories represent your investments. You can classify your investments
          in any way that makes sense to you.
        </p>
        <p class="text-secondary">
          One option is to to have each category represent a specific stock or ETF.
          Alternatively a broader approach is to classify your investments based on the
          types of accounts they're allocated to such as the below suggestions.
        </p>
        <p class="text-secondary">
          You're welcome to change these initial suggestions.
        </p>
      </b-col>
    </b-row>
    <b-form id="form">
      <b-row v-for="(category, index) in categories" :key="index" class="mt-2">
        <b-col cols="2">
          <b-form-checkbox
            v-if="index !== 0"
            v-model="category.is_active"
          />
        </b-col>
        <b-col cols="5">
          <b-form-input
            v-model="category.name"
            size="sm"
            placeholder="Category Name"
            :disabled="!category.is_active"
            :required="category.is_active"
          />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-right">
          <i class="text-secondary">
            * You can always add to or change these after the setup process under
            <strong>My Data</strong>.
          </i>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="text-right">
          <b-button size="sm" variant="info" @click="onClickNext">
            <b-spinner v-if="fetching" small />
            <span v-else>Save & Next Step</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import Api from "@/api";

export default {
    data() {
        return {
            fetching: false,
            categories: [
                {
                    is_active: true,
                    name: "Taxable Brokerage",
                },
                {
                    is_active: true,
                    name: "401K",
                },
                {
                    is_active: true,
                    name: "Roth IRA",
                },
                {
                    is_active: false,
                    name: "",
                },
                {
                    is_active: false,
                    name: "",
                },
            ],
        };
    },
    methods: {
        onClickNext() {
            const form = document.getElementById("form");
            if (form.checkValidity()) {
                this.fetching = true;
                const data = this.categories.filter((el) => el.is_active);
                Api.createCategory("saving", data)
                    .then((res) => {
                        this.fetching = false;
                        this.$store.commit("onboarding/updateNumSavingCategories", res.data.length);
                        this.$store.commit("onboarding/incrementOnboardingStep");
                    })
                    .catch((err) => {
                        this.fetching = false;
                        this.$bvToast.toast("Failed to create categories", {
                            title: "Failed",
                            variant: "danger",
                            autoHideDelay: 2500,
                        });
                        console.log(err.response);
                    });
            } else {
                form.classList.add("was-validated");
            }
        },
    },
};
</script>